
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M22.5 21.522a6.848 6.848 0 100-13.696 6.848 6.848 0 000 13.696zM36.196 25.435a4.891 4.891 0 100-9.783 4.891 4.891 0 000 9.783zM8.943 25.435a4.891 4.891 0 100-9.783 4.891 4.891 0 000 9.783zM22.5 23.478c-7.012 0-12.717 5.705-12.717 12.718 0 .54.438.978.978.978h23.478c.54 0 .979-.438.979-.978 0-7.012-5.706-12.718-12.718-12.718zM10.63 27.603a8.777 8.777 0 00-1.826-.212C3.95 27.391 0 31.341 0 36.196c0 .54.438.978.978.978h7.028a2.901 2.901 0 01-.18-.978c0-3.211 1.049-6.175 2.804-8.593zM36.196 27.391c-.619 0-1.227.085-1.826.212a14.581 14.581 0 012.804 8.593c0 .344-.07.67-.18.978h7.028c.54 0 .978-.438.978-.978 0-4.854-3.95-8.805-8.804-8.805z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h45v45H0z"}})])])])
          )
        }
      }
    